module.exports = __webpack_public_path__ + "img/nav_share.763ebbe5.svg";